import React from 'react'
import {Filler} from './Filler'
import './ProgressBar.css'

export const ProgressBar = props => {
    return <div className="ProgressBar">
        <Filler percentage={props.percentage} color={props.color} processing={props.processing}/>
    </div>
}
